/***
 * 设备id
 * @type {string | string}
 */
export const deviceId = (window || {
  navigator: {
    userAgent: ''
  }
}).navigator.userAgent

/***
 * 设备类型
 * @type {string}
 */
export const deviceType = '2'



// WEBPACK FOOTER //
// ./src/utils/device.js